import { render, staticRenderFns } from "./ManageAcademyDocument.vue?vue&type=template&id=2d09df17&scoped=true"
import script from "./ManageAcademyDocument.vue?vue&type=script&lang=js"
export * from "./ManageAcademyDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d09df17",
  null
  
)

export default component.exports